import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';

import LoginSignUpModal from '../../../common/components/login/LoginModal';

import Megaphone from './Megaphone';

import './AlertsNotLogged.scss';

const AlertsNotLogged = memo(
  ({ handleModalOpen, handleModalClose, isModalOpen }) => (
    <div className="non-logged-alerts" data-test="non-logged-alerts">
      <Megaphone className="non-logged-alerts__megaphone" />
      <p className="non-logged-alerts__title">
        {trans('alerts.body.not_logged.title')}
      </p>
      <p className="non-logged-alerts__message">
        {trans('alerts.body.not_logged.text1')}
      </p>
      <Button onClick={handleModalOpen} className="non-logged-alerts__register">
        {trans('alerts.body.not_logged.sign_up')}
      </Button>
      <LoginSignUpModal
        onClose={handleModalClose}
        initialAction="signup"
        isOpen={isModalOpen}
      />
    </div>
  )
);

AlertsNotLogged.propTypes = {
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired
};

export default AlertsNotLogged;
